import { useMutation } from "@tanstack/react-query";
import { objectToFormData } from "../../helpers/objectToFormData";
import type { EntityType } from "@repo/types/enums";
import { useApiAccess } from "@repo/hooks/contexts";
import type { ExecutionResponse } from "@repo/types/responses";

export function useUploadFile() {
  const { apiClient } = useApiAccess();

  return useMutation<
    ExecutionResponse,
    unknown,
    { file: File; entityType: EntityType }
  >({
    mutationFn: async ({ file, entityType }) => {
      const formData = objectToFormData({
        file,
        entityType,
      });

      const res = await apiClient.post<ExecutionResponse>(
        "/File/UploadNew",
        formData,
      );

      return res.data;
    },
  });
}
